import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key for the given assignment calculation type.
 * It is used to translate the type of calculation for assignments in partnerships.
 * @param type
 * @returns
 */
export function getCalculationTypeTranslationKey(
	type: Enums<"assignmentCalculationType">,
): TranslationKey {
	switch (type) {
		case "hourly":
			return "partners.hourly";
		case "service":
			return "partners.service";
	}
}
